import { Link } from "react-router-dom";
import { Check, Lock } from "lucide-react";
import { LOGO_FULL } from "@/components/common";

export const STEP_NAMES = ["Trouve ton idée", "Choisis ton business", "Prépare ton offre", "Vérifie l'intérêt des clients", "Prépare les prochaines étapes"];

export function ChallengeShell({ children, back = "/dashboard/challenge", backLabel = "Mon challenge" }) {
  return (
    <div className="min-h-screen bg-[#F4F8F9]" data-testid="challenge-shell">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-[#E1ECEF] pt-safe">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between gap-3">
          <Link to="/" data-testid="challenge-home-link"><img src={LOGO_FULL} alt="Sidebizz" className="h-7" /></Link>
          <Link to={back} className="text-sm font-bold text-[#13B698] min-h-[44px] flex items-center" data-testid="challenge-back-link">{backLabel}</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-5 pb-28">{children}</main>
    </div>
  );
}

export function StepBar({ days, current }) {
  return (
    <ol className="grid grid-cols-5 gap-1.5" aria-label="Progression du challenge" data-testid="challenge-progress">
      {(days || []).map((d) => {
        const done = d.state === "completed";
        const cur = d.day === current;
        return (
          <li key={d.day} className="flex flex-col items-center gap-1" data-testid={`challenge-progress-day-${d.day}`}>
            <span className={`h-9 w-9 rounded-full flex items-center justify-center text-sm font-bold ${done ? "bg-[#13B698] text-white" : cur ? "bg-[#13283A] text-white" : d.state === "available" ? "bg-white border-2 border-[#13B698] text-[#13283A]" : "bg-[#E1ECEF] text-[#7D8C96]"}`}>
              {done ? <Check className="h-4 w-4" strokeWidth={3} /> : d.state === "locked" ? <Lock className="h-3.5 w-3.5" /> : d.day}
            </span>
            <span className="text-[10px] leading-tight text-center text-[#5C6B73] font-semibold hidden sm:block">{STEP_NAMES[d.day - 1]}</span>
          </li>
        );
      })}
    </ol>
  );
}

export const fmtUnlock = (iso) => new Date(iso).toLocaleString("fr-FR", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" });
export const rsFr = (n) => `Rs ${Number(n).toLocaleString("en-US")}`;
